/**
 * Sidebar Navigation Component - Vertical Icon Style
 */

import { useNavigate, useLocation } from "react-router-dom";
import { Layout } from "antd";
import {
  FileTextOutlined,
  AppstoreOutlined,
  UserOutlined,
  IdcardOutlined,
} from "@ant-design/icons";
import { useConfigStore } from "@ifa/utils";
import "./Sidebar.css";

const { Sider } = Layout;

export function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const brandConfig = useConfigStore((state) => state.brandConfig);

  const menuItems = [
    {
      key: "/orders",
      icon: <FileTextOutlined />,
      label: "訂單",
    },
    {
      key: "/products",
      icon: <AppstoreOutlined />,
      label: "產品",
    },
    {
      key: "/customers",
      icon: <UserOutlined />,
      label: "客戶",
    },
    {
      key: "/profile",
      icon: <IdcardOutlined />,
      label: "我的",
    },
  ];

  return (
    <div style={{ borderRight: "1px solid #E2E8F0" }}>
      <Sider
        width={80}
        theme="light"
        trigger={null}
        style={{
          backgroundColor: "#FFFFFF",
          borderRadius: "10px",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          zIndex: 100,
          height: "100%",
          margin: "0 0 0 0",
        }}
      >
        {/* Logo 区域 */}
        <div className="sidebar-logo">
          <img src={brandConfig.solidLogo} alt="IFA" className="sidebar-logo-img" />
        </div>

        {/* 菜单 */}
        <div className="custom-menu">
          {menuItems.map((item) => {
            const isActive = location.pathname.startsWith(item.key);
            return (
              <div
                key={item.key}
                className={`custom-menu-item ${isActive ? "active" : ""}`}
                onClick={() => navigate(item.key)}
              >
                <div className="menu-icon">{item.icon}</div>
                <div className="menu-label">{item.label}</div>
              </div>
            );
          })}
        </div>
      </Sider>
    </div>
  );
}
